module.exports = __webpack_public_path__ + "static/media/auroraunknown.167e1625.svg";